import React from 'react';
import { connect } from 'react-redux';
import { cartAddItem } from '../../../actions/cart';
import { cartItemInstructionsUpdate } from '../../../actions/cartItem';

class MenuItemSubmitButton extends React.Component {

    constructor(props) {
        super(props);

        this.onChangeInstructions = this.onChangeInstructions.bind(this);
    }

    onChangeInstructions(instructions) {
        this.props.dispatch(cartItemInstructionsUpdate(instructions))
    }

    render() {
        // @TODO: ask Brandon why this was commented out
     //   if (this.props.isOpen == "1") {
            return (
                <a
                    onClick={() => {
                        this.props.dispatch(cartAddItem(this.props.itemtype, {
                            ...this.props.cartItem,
                            total_item_price: this.props.price
                        }));

                        if (this.props.showCompleted) {
                            this.props.showCompleted();
                        }
                    }}
                >
                    <div className="submit-menu-item-window">
                        <p className="button-label">ADD TO ORDER</p>
                        <p className="button-price">${this.props.price.toFixed(2)}</p>
                    </div>
                </a>
            );
        }
//        else {
//            return <div />;
//        }
//    }
};

const mapStateToProps = (state) => {

    return {
        isOpen: state.currentLocation.info.location.open,
        cartItem: state.cartItem,
        cart: state.cart
    };
};

export default connect(mapStateToProps)(MenuItemSubmitButton);